import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "施設設定", -1)),
      _createVNode(_component_v_spacer)
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_table, { class: "mt-4" }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "text-left" }, "施設名"),
            _createElementVNode("th", { class: "text-left" }, "住所"),
            _createElementVNode("th", { class: "text-left" }, "電話番号"),
            _createElementVNode("th", { class: "text-left" }, "施設メールアドレス"),
            _createElementVNode("th", { class: "text-left" })
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nurseries, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.nurseryId
            }, [
              _createElementVNode("td", null, _toDisplayString(item.nurseryName), 1),
              _createElementVNode("td", null, _toDisplayString(`${item.prefecture ?? ""}${item.address ?? ""}${item.building ?? ""}`), 1),
              _createElementVNode("td", null, _toDisplayString(item.phoneNumber), 1),
              _createElementVNode("td", null, _toDisplayString(item.representativeEmail), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_v_btn, {
                  to: `/school/${item.nurseryId}`,
                  color: "primary",
                  variant: "outlined",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" 編集 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}